$(document).ready(function () {
    let login = $('.mylla-login-form');
    if (login) {
        let forgottenPasswordButton = $(login).find('.mylla-login-form__forgotten-password-btn');
        let forgottenPasswordForm = $(login).find('.mylla-login-form__forgotten-password');

        if (forgottenPasswordButton && forgottenPasswordForm) {
            $(forgottenPasswordButton).on('click', function () {
                forgottenPasswordForm.show();
            })
        }
    }

    let forgottenPasswordForm = $('.mylla-login-form__forgotten-password');
    if (forgottenPasswordForm) {
        $(forgottenPasswordForm).submit(function (event) {
            event.preventDefault();
            var form = $(this);
            if (form.valid()) {
                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form.serialize(),
                    success: function (result) {
                        form.find('.forgotten-password__result').html(result);
                    }
                });
            }
        });
    }
});